import { Route, Routes, Outlet, Navigate } from 'react-router-dom'
import { PageLink, PageTitle } from '../../../_metronic/layout/core'
import DocumentTitle from 'react-document-title'
import LanesList from './LanesList'

const lanesBreadcrumbs: Array<PageLink> = [
  {
    title: 'Lanes',
    path: '/lanes',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const LanesPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='list'
          element={
            <>
              <DocumentTitle title={process.env.REACT_APP_NAME + ' | Lanes'}></DocumentTitle>
              <PageTitle breadcrumbs={lanesBreadcrumbs}>List</PageTitle>
              <LanesList />
            </>
          }
        />
        <Route index element={<Navigate to='/lanes/list' />} />
      </Route>
    </Routes>
  )
}

export default LanesPage
